import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#259354" }}>Results</span>
            </h2>
            <p>
              Mart Book app is very advanced for its industry and it enables
              farmers to get ahead of the ineffective conventional practices and
              revolutionize livestock farming for more productive results. This
              user-oriented mobile app provides a personalized experience and
              serves its targeted audience very well.
            </p>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/martbook/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1011}
              height={791}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
